export default "__VITE_ASSET__ByRwPrNu__"